import API from '../../shared/Config/API';
import APIEndpoints from '../../shared/Config/APIEndpoints';
import { CLIENT_MASTER_DATA_PARAMS } from '../../shared/Constants/Constants';

const getAccount = async () => {
  try {
    return await API.get(APIEndpoints.GET_ACCOUNT, {
      ignoreError: true,
    });
  } catch (error) {
    console.error(error);
  }
};
const updateDevice = async (payload) => {
  return await API.post(APIEndpoints.DEVICE_DETAILS, payload, {
    ignoreError: true,
  });
};
const fetchMyClients = async () => {
  try {
    return await API.get(APIEndpoints.CENTRAL_ONBOARDING.CLIENTS, null, CLIENT_MASTER_DATA_PARAMS);
  } catch (error) {
    console.error(error);
  }
};

const fetchInvoiceSpecs = async () => {
  try {
    return await API.get(APIEndpoints.INVOICE_SPECS,null, {page:0, size:5000});
  } catch (error) {
    console.error(error);
  }
};

const updateProfileInfo = async (payload) => {
  return await API.put(APIEndpoints.UPDATE_PROFILE_INFO_DETAILS, payload);
};
const updateContactPerson = async (payload) => {
  return await API.put(APIEndpoints.UPDATE_CONTACT_PERSON_DETAILS, payload);
};
const uploadLogo = async (payload) => {
  return await API.post(APIEndpoints.UPLOAD_PROFILE_LOGO, payload);
};
const changePassword = async (payload) => {
  return await API.post(APIEndpoints.UPDATE_PASSWORD, payload);
};
const updateProfile = async (payload) => {
  return await API.put(APIEndpoints.UPDATE_PROFILE, payload);
};
const getGlobalNotifications = async () => {
  return await API.get(APIEndpoints.GET_ACTIVITY_LOG, {
    ignoreError: true,
  });
};
const setNotificationTapped = async (payload) => {
  return await API.post(APIEndpoints.SET_LOG_READ + '?id=' + payload);
};
const getTimelineLogs = async () => {
  const response = await API.get(APIEndpoints.GET_TIMELINE_LOG);
  return response;
};

export const AccountAPI = {
  getAccount,
  updateDevice,
  fetchMyClients,
  fetchInvoiceSpecs,
  updateProfileInfo,
  updateContactPerson,
  uploadLogo,
  changePassword,
  updateProfile,
  getGlobalNotifications,
  setNotificationTapped,
  getTimelineLogs,
};
